const commentReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default commentReducer;